import { ComponentProps } from 'react'
import { useNavigation } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

export const AppContainer = ({ className, ...props }: ComponentProps<'div'>) => {
  const { state } = useNavigation()
  const opacity = state === 'loading' ? 'opacity-75' : 'opacity-100'
  return (
    <div
      className={twMerge(
        'flex flex-col flex-nowrap h-[100dvh] content-start items-start transform',
        opacity,
        className
      )}
      {...props}
    />
  )
}
